<template>
	<div>
		<el-container>
			<!--左导航-->
			<el-aside :width="isCollapse ? '64px' : '200px'" class="aside-with-footer">
				<div class="aside-inner">
					<menu_navigation :collapse="isCollapse"></menu_navigation>
					<div class="aside-footer">
						深圳美铭科技
					</div>
				</div>
			</el-aside>
			<!--右-->
			<el-container class="you_el-container">
				<!--页头-->
				<el-header>
					<div class="header-div">
						<div class="header-left">
							<el-tooltip class="item" effect="dark" :content="isCollapse ? '展开导航' : '收起导航'" placement="bottom">
								<el-button type="info" :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" circle @click="toggleCollapse"></el-button>
							</el-tooltip>
							<h1 class="header-title">驾驶人自助拍照体检系统 V2.0</h1>
						</div>
						<div class="header-right">
							<span class="user-info">
								{{realName}}，
								待审核 {{waitCount}} 条，
								审核通过 {{passedCount}} 条，
								审核不通过 {{faildCount}} 条，
								已审核 {{auditedCount}} 条
							</span>
							<el-tooltip class="item" effect="dark" content="刷新审核统计" placement="top">
								<el-button type="info" icon="el-icon-refresh" circle @click="refreshAuditStats" :loading="refreshing"></el-button>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="设置" placement="top">
								<el-button type="info" icon="el-icon-s-tools" circle @click="openDialog()"></el-button>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" :content="soundEnabled ? '声音提醒：开启' : '声音提醒：关闭'" placement="top">
								<el-switch
									v-model="soundEnabled"
									@change="handleSoundChange"
									active-text=""
									inactive-text=""
									active-color="#13ce66"
									inactive-color="#ff4949">
								</el-switch>
							</el-tooltip>
							<el-button v-on:click="Unlogin()" type="danger">注销登录<i class="el-icon-right el-icon--right"></i></el-button>
						</div>
					</div>
				</el-header>
				<!--主体-->
				<el-main>
					<router-view></router-view>
				</el-main>
			</el-container>
		</el-container>
		
		
		<!--dialog-->
		<el-dialog title="设置不通过原因" :visible.sync="dialogFormVisible" width="45%" :show-close="false"
			:close-on-click-modal="false" :close-on-press-escape="false">
			<el-tabs tab-position="left" style="margin-right: 50px;">
			    <el-tab-pane label="上肢检测">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e2_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e2_reasons" key="item" size="medium" @click="del_reason('e2_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
			    <el-tab-pane label="下肢检测">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e3_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e3_reasons" key="item" size="medium" @click="del_reason('e3_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
			    <el-tab-pane label="躯干检测">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e1_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e1_reasons" key="item" size="medium" @click="del_reason('e1_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
			    <el-tab-pane label="视力检测">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e4_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e4_reasons" key="item" size="medium" @click="del_reason('e4_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
				<el-tab-pane label="辩色力检测">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e5_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e5_reasons" key="item" size="medium" @click="del_reason('e5_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
				<el-tab-pane label="听力检测">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e6_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e6_reasons" key="item" size="medium" @click="del_reason('e6_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
				<el-tab-pane label="身高检测">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e7_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e7_reasons" key="item" size="medium" @click="del_reason('e7_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
				<el-tab-pane label="现场照片">
					<el-input placeholder="自定义不通过原因" v-model="reason" class="input-with-select">
					    <el-button slot="append" @click="append(ReasonList.e8_reasons)" icon="el-icon-plus">添加</el-button>
					</el-input>
					<el-button icon="el-icon-delete" v-for="item in ReasonList.e8_reasons" key="item" size="medium" @click="del_reason('e8_reasons',item)" style="margin: 4px;">{{item}}</el-button>
				</el-tab-pane>
			  </el-tabs>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import menu_navigation from '../components/common/menu.vue'
	import axios from 'axios';
	import { post } from '../../public/request/request.js';
	import { createWatermark, removeWatermark } from '../utils/watermark.js';
	export default {
		data() {
			return {
				title: "xxxff",
				
				/**
				 * el-dialog 参数
				 */
				dialogFormVisible: false,
				/**
				 * 不通过原因列表
				 */
				ReasonList:{},
				reason: "",
				/**
				 * 用户真实姓名
				 */
				realName: "",
				/**
				 * 当日审核统计
				 */
				waitCount: 0,
				passedCount: 0,
				faildCount: 0,
				auditedCount: 0,
				/**
				 * 声音提醒开关（默认开启）
				 */
				soundEnabled: true,
				/**
				 * 左侧导航是否折叠
				 */
				isCollapse: false,
				/**
				 * 刷新审核统计加载状态
				 */
				refreshing: false,
			}
		},
		components: {
			menu_navigation,
		},
		created() {
			// 加载用户信息
			this.loadUserInfo();
			
			// 加载不通过原因
			this.GetReasonList();
			
			// 加载声音开关状态
			this.loadSoundSetting();
			
			// 加载导航折叠状态
			this.loadCollapseSetting();
			
			// 监听审核统计事件
			window.addEventListener('auditSuccess', this.updateAuditStats);
			
			// alert("你好");
			// this.$router.push({path:'/home'});
			//this.fetchUserData();
		},
		mounted() {
			// 创建水印（登录成功后显示）
			this.initWatermark();
		},
		beforeDestroy() {
			// 移除水印
			removeWatermark();
			// 移除事件监听
			window.removeEventListener('auditSuccess', this.updateAuditStats);
		},
		methods: {
			/**
			 * 加载用户信息
			 */
			loadUserInfo() {
				try {
					// 从 sessionStorage 读取 loginInfo
					const loginInfoStr = sessionStorage.getItem('loginInfo');
					if (loginInfoStr) {
						const loginInfo = JSON.parse(loginInfoStr);
						this.realName = loginInfo.realName || '未知用户';
					}
					
					// 从 sessionStorage 读取当日审核统计
					const auditStatsStr = sessionStorage.getItem('auditStats');
					if (auditStatsStr) {
						const stats = JSON.parse(auditStatsStr);
						this.waitCount = Number(stats.waitCount || 0);
						this.passedCount = Number(stats.passedCount || 0);
						this.faildCount = Number(stats.faildCount || 0);
						this.auditedCount = Number(stats.auditedCount || 0);
					} else {
						this.resetAuditStats();
					}
				} catch (error) {
					console.error('加载用户信息失败:', error);
					this.realName = '未知用户';
					this.auditCount = 0;
				}
			},
			/**
			 * 更新审核统计
			 */
			updateAuditStats(event) {
				if (event && event.detail) {
					const stats = event.detail;
					this.waitCount = Number(stats.waitCount || 0);
					this.passedCount = Number(stats.passedCount || 0);
					this.faildCount = Number(stats.faildCount || 0);
					this.auditedCount = Number(stats.auditedCount || 0);
					sessionStorage.setItem('auditStats', JSON.stringify({
						waitCount: this.waitCount,
						passedCount: this.passedCount,
						faildCount: this.faildCount,
						auditedCount: this.auditedCount
					}));
					console.log('审核统计已更新:', stats);
				}
			},
			/**
			 * 加载声音开关设置
			 */
			loadSoundSetting() {
				try {
					const soundSetting = localStorage.getItem('soundEnabled');
					if (soundSetting !== null) {
						this.soundEnabled = soundSetting === 'true';
					} else {
						// 默认开启
						this.soundEnabled = true;
						localStorage.setItem('soundEnabled', 'true');
					}
				} catch (error) {
					console.error('加载声音设置失败:', error);
					this.soundEnabled = true;
				}
			},
			/**
			 * 加载导航折叠设置
			 */
			loadCollapseSetting() {
				try {
					const collapseSetting = localStorage.getItem('menuCollapse');
					if (collapseSetting !== null) {
						this.isCollapse = collapseSetting === 'true';
					} else {
						// 默认展开
						this.isCollapse = false;
						localStorage.setItem('menuCollapse', 'false');
					}
				} catch (error) {
					console.error('加载导航折叠设置失败:', error);
					this.isCollapse = false;
				}
			},
			/**
			 * 重置审核统计
			 */
			resetAuditStats() {
				this.waitCount = 0;
				this.passedCount = 0;
				this.faildCount = 0;
				this.auditedCount = 0;
				sessionStorage.setItem('auditStats', JSON.stringify({
					waitCount: 0,
					passedCount: 0,
					faildCount: 0,
					auditedCount: 0
				}));
			},
			/**
			 * 初始化水印
			 */
			initWatermark() {
				// 检查是否已登录
				const isLoggedIn = sessionStorage.getItem('_login') === 'true';
				if (isLoggedIn) {
					// 获取用户信息
					try {
						const loginInfoStr = sessionStorage.getItem('loginInfo');
						if (loginInfoStr) {
							const loginInfo = JSON.parse(loginInfoStr);
							const account = loginInfo.account || '';
							const realName = loginInfo.realName || '';
							const loginTime = loginInfo.loginTime || '';
							const loginIp = loginInfo.loginIp || '';
							
							// 格式化日期时间
							let formattedTime = '';
							if (loginTime) {
								try {
									const date = new Date(loginTime);
									const year = date.getFullYear();
									const month = String(date.getMonth() + 1).padStart(2, '0');
									const day = String(date.getDate()).padStart(2, '0');
									formattedTime = `${year}-${month}-${day}`;
								} catch (e) {
									formattedTime = loginTime;
								}
							}
							
							// 构建水印文本：账号 （姓名） 日期 （IP）
							let watermarkText = '';
							if (account) {
								watermarkText = account;
								if (realName) {
									watermarkText += ` （${realName}）`;
								}
								if (formattedTime) {
									watermarkText += ` ${formattedTime}`;
								}
								if (loginIp) {
									watermarkText += ` （${loginIp}）`;
								}
							} else {
								// 如果没有账号，使用默认水印
								watermarkText = '驾驶人自助拍照体检系统';
							}
							
							// 创建水印
							createWatermark(watermarkText, {
								fontSize: 18,
								fontColor: 'rgba(0, 0, 0, 0.15)',
								width: 500,
								height: 400,
								rotate: -20,
								zIndex: 9999
							});
						} else {
							// 如果没有用户信息，使用默认水印
							createWatermark('驾驶人自助拍照体检系统', {
								fontSize: 18,
								fontColor: 'rgba(0, 0, 0, 0.12)',
								width: 500,
								height: 350,
								rotate: -20,
								zIndex: 9999
							});
						}
					} catch (error) {
						console.error('初始化水印失败:', error);
					}
				}
			},
			/**
			 * 刷新审核统计
			 */
			refreshAuditStats() {
				this.refreshing = true;
				post('416', null)
					.then(response => {
						if (response.data.result == 0 && response.data.data) {
							const auditStats = {
								waitCount: Number(response.data.data.waitCount || 0),
								passedCount: Number(response.data.data.passedCount || 0),
								faildCount: Number(response.data.data.faildCount || 0),
								auditedCount: Number(response.data.data.auditedCount || 0)
							};
							// 更新本地数据
							this.waitCount = auditStats.waitCount;
							this.passedCount = auditStats.passedCount;
							this.faildCount = auditStats.faildCount;
							this.auditedCount = auditStats.auditedCount;
							// 保存到 sessionStorage
							sessionStorage.setItem('auditStats', JSON.stringify(auditStats));
							// 触发事件通知其他组件
							const event = new CustomEvent('auditSuccess', {
								detail: auditStats
							});
							window.dispatchEvent(event);
							//this.$message.success('审核统计已刷新');
							console.log('审核统计已刷新:', auditStats);
						} else {
							this.$message.error('刷新失败：' + (response.data.message || '未知错误'));
						}
						this.refreshing = false;
					})
					.catch(error => {
						this.$message.error((error && error.userMessage) || '刷新审核统计失败');
						console.error('刷新审核统计失败:', error);
						this.refreshing = false;
					});
			},
			/**
			 * 处理声音开关变化
			 */
			handleSoundChange(value) {
				localStorage.setItem('soundEnabled', value.toString());
				console.log('声音提醒已', value ? '开启' : '关闭');
			},
			/**
			 * 切换左侧导航折叠状态
			 */
			toggleCollapse() {
				this.isCollapse = !this.isCollapse;
				// 保存折叠状态到 localStorage
				localStorage.setItem('menuCollapse', this.isCollapse.toString());
			},
			/**
			 * 加载不通过原因
			 */
			GetReasonList() {
				var reasonList = localStorage.getItem('reasonList');
				if(reasonList == null || reasonList=="" || reasonList == undefined){
					console.log("----------正在写入------------");
					reasonList = '{"e1_reasons":["转头不符合要求"],"e2_reasons":["却少手指","握拳不符合要求","手掌不符合要求"],"e3_reasons":["抬脚不符合要求"],"e4_reasons":["未正确使用遮眼罩"],"e5_reasons":["辩色力检测不合格"],"e6_reasons":["听力检测不合格"],"e7_reasons":["身高检测不合格"],"e8_reasons":["现场照片不合格"]}';
					localStorage.setItem('reasonList',reasonList);
				}
				this.ReasonList = JSON.parse(reasonList);
			},
			/**
			 * 打开设置弹框
			 */
			openDialog() {
				// 加载不通过原因
				this.GetReasonList();
				this.dialogFormVisible = true;
			},
			/**
			 * 设置框,确认按钮
			 */
			submitForm() {
				localStorage.setItem('reasonList',JSON.stringify(this.ReasonList));
				this.dialogFormVisible = false;
			},
			/**
			 * 添加不通过原因
			 */
			append(reasons){
				if(this.reason != ""){
					reasons.push(this.reason);
					this.reason = "";
				}
			},
			/**
			 * 移除原因
			 */
			del_reason(reasonsName,reason){
				this.ReasonList[reasonsName] = this.ReasonList[reasonsName].filter(item => item !== reason); 
			},
			
			fetchUserData() {
				this.$router.push({
					path: '/home'
				});
				axios.get('https://v1.jinrishici.com/all.json')
					.then(response => {
						// this.user = response.data;
						//alert(JSON.stringify(response.data)); 
						this.title = JSON.stringify(response.data);
						this.content = response.data.content;
					})
					.catch(error => {
						console.error('There was an error!', error);
					});
			},
			Unlogin() {
				sessionStorage['_login'] = 'false';
			// 清空审核统计
			sessionStorage.removeItem('auditStats');
				this.$router.push({
					path: '/login'
				});
			}
		},
		/**
		 * 组件销毁前
		 */
		beforeDestroy() {
			// 移除水印
			removeWatermark();
			// 移除事件监听
			window.removeEventListener('auditSuccess', this.updateAuditStats);
		}
	}
</script>

<style>
	.el-header,
	.el-footer {
		background-color: #D0D0D0;
		color: #333;
		text-align: center;
		line-height: 60px;
		padding: 0 16px;
		overflow: hidden;
	}

	.el-aside {
		background-color: #2f3e4e;
		color: #333;
		text-align: left;
		height: 100vh;
		transition: width 0.3s;
		overflow: hidden;
	}

	.aside-with-footer {
		display: flex;
		flex-direction: column;
	}

	.aside-inner {
		display: flex;
		flex-direction: column;
		height: 100%;
		min-height: 0;
	}

	.aside-footer {
		margin-top: auto;
		text-align: center;
		color: #ffffff;
		font-size: 12px;
		padding: 10px 5px;
		opacity: 0.8;
	}

	.you_el-container {
		height: 100vh;
	}

	.el-main {
		/* background-color: #E9EEF3; */
		background-color: #FFFFFF;
		color: #000;
		text-align: left;
		line-height: 40px;
	}


	* {
		margin: 0;
	}

	.el-menu {
		border: none !important;
	}

	.header-div {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 12px;
		min-width: 0;
		height: 100%;
	}
	
	.header-left {
		display: flex;
		align-items: center;
		gap: 15px;
		flex: 0 1 auto;
		min-width: 0;
		overflow: hidden;
	}
	
	.header-title {
		margin: 0;
		font-size: 24px;
		font-weight: 600;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.header-right {
		display: flex;
		align-items: center;
		gap: 12px;
		flex: 0 0 auto;
		flex-shrink: 0;
		flex-wrap: nowrap;
		margin-left: auto;
	}
	
	.user-info {
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin-right: 4px;
		white-space: nowrap;
		flex-shrink: 1;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.header-right .el-button,
	.header-right .el-switch {
		flex-shrink: 0;
	}

	@media (max-width: 1200px) {
		.header-title {
			display: none;
		}
	}

	@media (max-width: 768px) {
		.header-right {
			gap: 8px;
		}

		.user-info {
			font-size: 14px;
		}

		.el-header {
			padding: 0 10px;
		}
	}
	
	.input-with-select{
	    margin: 5px 0px 5px 0px;
	}
</style>